import { Fragment, useMemo } from "react";
import PropTypes from "prop-types";
import toastr from "toastr";
import { withTranslation } from "react-i18next";
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { useGetAllCertsNotPaginated } from "../../../api/certs";
import { mediaUrl } from "../../../helpers/mediaHelper";

function formatFriendlyTitle(input) {
  if (!input) return "";
  const cleaned = input
    .replace(/[_-]+/g, " ")
    .replace(/\//g, " / ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
  return cleaned.replace(/\b\w/g, (char) => char.toUpperCase());
}

function WorkerIdentityCard({
  uploadSelfieUrl,
  qrPng,
  userSlug,
  userId,
  t,
}) {
  const { data: certsDataRes } = useGetAllCertsNotPaginated();
  const certsData = useMemo(() => {
    const raw = certsDataRes?.data?.data || certsDataRes?.data || [];
    return Array.isArray(raw) ? raw : [];
  }, [certsDataRes]);

  const tt = (key, fallback) => t(key, { defaultValue: fallback ?? key });

  // Worker QR download — hidden while QR UI is disabled
  // const downloadQRCode = async () => {
  //   const qrUrl = mediaUrl(qrPng);
  //   if (!qrUrl) return;
  //
  //   try {
  //     const response = await fetch(qrUrl);
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = `worker-qr-code-${userSlug || userId || "qr"}.png`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Error downloading QR code:", error);
  //     toastr.error(t("downloadError") || "Failed to download QR code.");
  //   }
  // };

  if (!uploadSelfieUrl) return null;

  return (
    <Card className="worker-dashboard-section border-0 shadow-sm mb-4">
      <CardBody className="p-4">
        <Row className="align-items-center">
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <div className="text-start">
              {uploadSelfieUrl ? (
                <div className="selfie-container">
                  <img
                    src={mediaUrl(uploadSelfieUrl)}
                    alt={t("uploadSelfie") || "Selfie"}
                    className="selfie-image"
                  />
                </div>
              ) : (
                <small className="text-muted d-block mb-3">
                  {t("noSelfieUploaded") || "No selfie uploaded yet."}
                </small>
              )}

              <div className="d-flex flex-wrap gap-2">
                {certsData
                  .filter((cert) => cert.icon)
                  .map((cert, index) => {
                    const friendlyTitle = formatFriendlyTitle(
                      cert.title || cert.titleToUse || cert.slug || ""
                    );
                    const tooltipTitle =
                      friendlyTitle ||
                      tt("certificateTitleFallback", "Certificate");
                    const tooltipId = `dashboard-cert-icon-${
                      cert.slug || cert.titleToUse || index
                    }`;
                    return (
                      <Fragment key={cert.slug || cert.titleToUse || index}>
                        <span
                          id={tooltipId}
                          className="cert-icon-badge"
                          style={{
                            border:
                              cert.type === "gold"
                                ? "2px solid #FFD700"
                                : "2px solid #C0C0C0",
                          }}
                        >
                          {cert.icon}
                        </span>
                        <UncontrolledTooltip placement="top" target={tooltipId}>
                          {tooltipTitle}
                        </UncontrolledTooltip>
                      </Fragment>
                    );
                  })}
              </div>
            </div>
          </Col>
          {/* Worker QR UI hidden
          {qrPng && (
            <Col xs={12} lg={6}>
              <div className="d-flex flex-column align-items-lg-end justify-content-center">
                <div
                  style={{
                    width: "120px",
                    height: "120px",
                    border: "2px solid #e9ecef",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f8f9fa",
                    padding: "8px",
                    marginBottom: "16px",
                  }}
                >
                  <img
                    src={mediaUrl(qrPng)}
                    alt={t("workerQRCode", "Worker QR Code")}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div className="text-lg-end mb-3 text-start text-lg-end">
                  <h6 className="mb-1 fw-bold">
                    {t("workerQRCode") || "Worker QR Code"}
                  </h6>
                  <small className="text-muted">
                    {t("scanQRCodeToViewProfile") ||
                      "Scan this QR code to view worker profile"}
                  </small>
                </div>
                <Button color="primary" onClick={downloadQRCode}>
                  <i className="mdi mdi-download me-2" />
                  {t("downloadQRCode") || "Download QR Code"}
                </Button>
              </div>
            </Col>
          )}
          */}
        </Row>
      </CardBody>
    </Card>
  );
}

WorkerIdentityCard.propTypes = {
  uploadSelfieUrl: PropTypes.string,
  qrPng: PropTypes.string,
  userSlug: PropTypes.string,
  userId: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(WorkerIdentityCard);
